import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useSafeContext } from '../../../../hooks/useSafeContext';
import { CorrectionContext } from '../../../../store/correctionStore';
import { DisplayPointType } from '../../../pages/Correction/constants';
import { Escalation } from '../Escalation';
import { Section, Step } from './parts/separations';
import { CheckListSection } from './sections/CheckListSection';
import { CommonPanel } from './sections/CommonPanel';
import { CustomerRemarksSection } from './sections/CustomerRemarksSection';
import { MonitorRuleSection } from './sections/MonitorRuleSection';
import { ResultFormSection } from './sections/ResultFormSection';

// TODO: [添削] テスト未実装
export const ReceiptContents: React.FC = () => {
  const {
    largeState: { state: $, mergeState },
  } = useSafeContext(CorrectionContext);

  useEffect(() => {
    const isNg = $.commentForms_ng?.find((item) => item.dp.type === DisplayPointType.APPLY_RECEIPT_CHECK_POINT);
    if (isNg) {
      const element = document.getElementById('resultInputs');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }, [$.commentForms_ng]);

  return (
    <>
      <Button variant="link" onClick={() => mergeState({ isEnqueteModal: true })}>
        アンケート設問一覧
      </Button>
      <Button variant="link" onClick={() => mergeState({ isReceiptInfoModal: true })}>
        レシート情報表示
      </Button>
      <Step name="STEP1">
        <Section title="全体のノート・NG・エスカレ履歴" description="下記ノートを確認し問題なければチェックOK">
          <CommonPanel
            displayPoint={{
              type: DisplayPointType.FOR_ALL,
              targetId: null,
            }}
            noForm
          />
        </Section>
        <Section title="却下承認依頼履歴">
          <Escalation isReject escaletes={$.res_rejectInfoDisplay?.rejectHistory ?? []} />
        </Section>
        <Section title="ユーザ入力備考欄及びNGリスト">
          <CustomerRemarksSection />
        </Section>
        <Section
          title="応募・購入証明情報"
          description="右記「購入証明情報」を確認し下記チェック項目に反していなければチェックOK"
        >
          <CheckListSection />
        </Section>
      </Step>
      <Step name="STEP2">
        <Section title="ルール・条件">
          <MonitorRuleSection />
        </Section>
        <div id="resultInputs">
          <Section title="添削結果入力">
            <ResultFormSection />
          </Section>
        </div>
      </Step>
    </>
  );
};
